// @flow
/**
 * @module Actions/Auth2FA
 * @desc 2FA Verifikasi Token actions
 */

import { ActionTypes } from "../constants";

/* Kirim kode OTP ke server */
export const Verify2FA = (otp) => ({
    type: ActionTypes.VERIFY_2FA,
    otp,
});

/* Bila server merespon sukses */
export const Verify2FASuccess = (response) => ({
    type: ActionTypes.VERIFY_2FA_SUCCESS,
    response,
});

/* Bila terjadi error (OTP salah, expired, dll) */
export const Verify2FAError = (error) => ({
    type: ActionTypes.VERIFY_2FA_ERROR,
    error,
});
